<form #newOrderForm="ngForm" (ngSubmit)="validate()">
  <div class="modal-body">
    <div class="content">
      <div class="form-group">
        <label class="form-label"
          [ngClass]="{'form-required': !contextService.fullContext.company.settings.orderDeliveryDateRequired}">
          {{ 'order.selectAddress' | translate }} :
        </label>
        <div class="input-icon-wrapper">
          <i class="input-icon fa fa-map-marked-alt"></i>
          <select [disabled]="contextService.fullContext.company.settings.orderAddressRequired"
            (change)="setAddress($event)" class="form-select" name="delivery-address" required #deliveryAddress>
            <option disabled selected value>{{ 'order.selectAddress' | translate}}</option>
            <option *ngFor="let address of datas.addresses"
              [selected]="address.code === datas.order.deliveryAddress.code" [value]="address.code">
              {{ address.name }},
              {{ address.address1 }}, {{ address.zipCode}} {{ address.city }}
            </option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <div class="input-icon-wrapper" *ngIf="!contextService.fullContext.company.settings.orderDeliveryDateRequired">
          <label class="form-label"
            [ngClass]="{'form-required': !contextService.fullContext.company.settings.orderDeliveryDateRequired}">
            {{ 'order.selectDate' | translate }} : <i class="fa fa-spin fa-circle-notch" *ngIf="loadingDates"></i>
          </label>
          <i class="input-icon fa fa-calendar-alt"></i>
          <select *ngIf="!dates"
            [disabled]="!datas.order.deliveryAddress || contextService.fullContext.company.settings.orderDeliveryDateRequired  || disableDateSelection"
            class="form-select" name="delivery-date">
            <option selected value>{{ 'order.selectDate' | translate}}</option>
          </select>
          <select *ngIf="dates"
            [disabled]="!datas.order.deliveryAddress || contextService.fullContext.company.settings.orderDeliveryDateRequired  || disableDateSelection"
            (change)="setDeliveryDate($event)" class="form-select" name="delivery-date" required #deliveryDate>
            <option *ngIf="!contextService.fullContext.company.settings.orderDeliveryDateRequired" value>
              {{ 'order.selectDate' | translate}}
            </option>
            <option *ngFor="let date of dates" [selected]="date.deliveryDate === datas.order.deliveryDate"
              [value]="date.deliveryDate">
              {{ date.comment }}
            </option>
          </select>
          <!--ORIGINAL : select *ngIf="dates" [(ngModel)]="datas.order.deliveryDate"
            [disabled]="!datas.order.deliveryAddress || contextService.fullContext.company.settings.orderDeliveryDateRequired"
            class="form-select" name="delivery-date" required #date="ngModel" [value]="datas.order.deliveryDate | stringToDate:'fullDate'">
            <option *ngIf="!contextService.fullContext.company.settings.orderDeliveryDateRequired" disabled selected
              value>{{ 'order.selectDate' | translate}}</option>
            <option *ngFor="let date of dates" [ngValue]="date">{{ date | stringToDate:'fullDate' }}</option>
          </select-->
        </div>
        <div class="input-icon-wrapper" *ngIf="contextService.fullContext.company.settings.orderDeliveryDateRequired">
          <i class="input-icon fa fa-calendar-alt"></i>
          <input type="text" class="form-input" disabled [value]="datas.order.deliveryDate | stringToDate:'fullDate'">
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">
          {{ 'order.customCode' | translate }}:
          <span class="tooltip" [attr.data-tooltip]="'order.customCodeTooltip' | translate">
            <i class="fa fa-info-circle"></i>
          </span>
        </label>
        <div class="input-icon-wrapper">
          <i class="input-icon fa fa-hashtag"></i>
          <input class="form-input" placeholder="{{ 'order.customCode' | translate }}" type="text" name="customCode"
            [(ngModel)]="datas.order.customCode" #customCode="ngModel" />
        </div>
        <p *ngIf="newOrderForm.submitted && customCode.invalid">{{ 'order.emptyDateError' | translate }}</p>
      </div>
      <!-- Commentaire client -->
      <div class="form-group">
        <label class="form-label">
          {{ 'order.headerComment' | translate }}:
          <span class="tooltip" [attr.data-tooltip]="'order.headerCommentTooltip' | translate">
            <i class="fa fa-info-circle"></i>
          </span>
        </label>
        <div class="input-icon-wrapper">
          <i class="input-icon fa fa-comment"></i>
          <textarea class="form-input" placeholder="{{ 'order.headerComment' | translate }}" type="text"
            name="headerComment" [(ngModel)]="datas.order.headerComment" #headerComment="ngModel" rows="10"
            maxlength="250"></textarea>
        </div>
        <p *ngIf="newOrderForm.submitted && headerComment.invalid">{{ 'order.headerCommentError' | translate }}</p>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn float-left" type="button" (click)="close()">
      <i class="fa fa-times"></i>
      {{ 'modal.cancelButton' | translate }}
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="disableValidation()">
      <i class="fa fa-check"></i>
      {{ 'modal.validateButton' | translate }}
    </button>
  </div>
</form>